







import {defineComponent, PropType} from "@vue/composition-api";
import AppLayout from "@tool/Layouts/AppLayout.vue";
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import BlockMessage from "@base/Components/BlockMessage.vue";
import InertiaDatatable from "@base/Components/InertiaDatatable.vue";
import {TeamEntityInterface} from "@tool/tool.types";
import AppTeamLayout from "@tool/Pages/App/Teams/AppTeamLayout.vue";
import TeamSettingsGeneralForm from "@tool/Pages/App/Teams/Settings/partials/TeamSettingsGeneralForm.vue";
import TeamSettingsMembers from "@tool/Pages/App/Teams/Settings/partials/TeamSettingsMembers.vue";
import {WithProps} from "@base/base.types";

export default defineComponent({
    components: {
        TeamSettingsMembers,
        TeamSettingsGeneralForm,
        AppTeamLayout,
        Breadcrumbs,
        AppLayout,
        ThemeBlock,
        BlockMessage,
        InertiaDatatable
    },
    props: {
        team: {
            type: Object as PropType<WithProps<TeamEntityInterface, 'owner_user' | 'members' | 'invitations'>>,
            required: true
        },

    },
})
